import React, { useState, useEffect } from "react";
import carregando from "../../assets/loading.gif";
import api from "../../services/api";
import Header from "../../Header";
import SideMenu from "../../SideMenu";
import Footer from "../../Footer";
import DataTable from "react-data-table-component";

export default function List_Cliente({ history }) {
  const [prod, setProd] = useState([]);
  const [loading, setLoading] = useState("");
  const [busca, setBusca] = useState("");
  const [rowsSel, setRowsSel] = useState([]);

  async function loadProd() {
    const query = "/treinamentos/empresa";
    const response = await api.get(query);
    const data = await response.data;
    //setProd(data);
    setProd(
      data.filter(
        (item) =>
          item.nome && item.nome.toLowerCase().includes(busca.toLowerCase())
      )
    );
    setLoading(false);
  }

  function efetivaBusca() {
    loadProd();
  }

  const goToPage = (state) => {
    history.push("/cliente/" + state._id);
  };

  useEffect(() => {
    setLoading(true);
    loadProd();
    setTimeout(() => {
      if (document.getElementById("menu_cliente")) {
        document.getElementById("menu_cliente").className = "active";
      }
    }, 50);
  }, []);

  async function handleRemove(id, item) {
    if (rowsSel.length > 0) {
      if (window.confirm("Confirma remoção dos itens selecionados ?")) {
        setLoading(true);
        rowsSel.map(async (item) => {
          await api
            .delete("treinamentos/empresa/" + item._id)
            .then((res) => {
              if (res.data.error != undefined) {
                alert(res.data.error);
                setLoading(false);
                return;
              } else {
                loadProd();
                setLoading(false);
              }
            })
            .catch((error) => {
              alert(error);
              setLoading(false);
              return;
            });
        });
      }
    } else {
      alert("Nenhum registro selecionado !");
    }
  }

  const handleChange = (state) => {
    setRowsSel(state.selectedRows);
  };

  const columns = [
    {
      name: "Nome",
      selector: row => row.nome,
      sortable: true,
    },
  ];

  return (
    <>
      <Header />
      <SideMenu />

      <div>
        <div className="content-wrapper">
          <section className="content-header">
            <h1>
              Clientes<small>( tabela clientes )</small>
            </h1>
          </section>

          <section className="content">
            <div className="row">
              <div className="col-xs-12">
                <div className="box">
                  {loading && (
                    <div style={{ alignItems: "center", textAlign: "center" }}>
                      <img src={carregando} width="80"></img>
                    </div>
                  )}
                  <div className="box-body table-responsive">
                    <div className="col-md-12 nopadding">
                      <div className="col-md-6 nopadding">
                        <button
                          type="button"
                          className="btn btn-success btn-flat margin"
                          onClick={() => {
                            history.push("/cliente/novo");
                          }}
                        >
                          Novo Cliente
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger btn-flat margin"
                          onClick={() => {
                            handleRemove("", "");
                          }}
                        >
                          Remover Selecionados
                        </button>
                      </div>
                      <div
                        className="col-md-6 text-right"
                        style={{ paddingTop: 10 }}
                      >
                        <input
                          placeholder={"Buscar por Nome"}
                          value={busca}
                          onChange={(event) => setBusca(event.target.value)}
                        />
                        <button onClick={efetivaBusca}>Buscar</button>
                      </div>
                    </div>

                    <DataTable
                      columns={columns}
                      data={prod}
                      onRowClicked={goToPage}
                      pointerOnHover
                      highlightOnHover
                      selectableRows // add for checkbox selection
                      Clicked
                      onSelectedRowsChange={handleChange}
                      noDataComponent={""}
                    />
                  </div>
                </div>
                {/* /.box */}
              </div>
            </div>
          </section>
          {/* /.content */}
        </div>
      </div>

      <Footer />
    </>
  );
}

//nome,
//descr,
//preco,
//imagem,
//promocao,
//idestabelecimento
